export enum ECategoryCriteria {
    Keywords = 1,
    Location = 2,
    Distance = 3
}
